import { render, staticRenderFns } from "./CreateTaxPlan.vue?vue&type=template&id=1518f54a&"
import script from "./CreateTaxPlan.vue?vue&type=script&lang=js&"
export * from "./CreateTaxPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports